import { createRoot } from 'react-dom/client';
import HeaderBanner from './HeaderBanner';

const mount = document.getElementById('js-banner-mount')!;
createRoot(mount).render(<HeaderBanner bannerType={'HEADER'}/>);
